import React, { useState, useEffect } from 'react';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import Popup from '../../Modal/PopUp';
import { makeStyles } from '@material-ui/core/styles';
// import EditService from '../EditService';
import AddServices from '../index';
import { isMobile } from 'react-device-detect';
import './ServiceAdded.scss';

const useStyles = makeStyles({
  popper: {
    width: 120,
    margin: '0 24px 0 0',
    boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    // backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
  list: {
    width: 160,
    backgroundColor: 'white'
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  }
})

function ServiceAdded({
  handleSnackbar,
  handleEditFlag,
  helper,
  helperTrue,
  helperFalse,
  getValues,
  listServices,
  setListServices,
  calculateProposalDetails,
  setExpanded,
}) {
    const [flagEdit, setFlagEdit] = useState(0);

    const FnEditService = () => {
        setFlagEdit(1)
        setAnchorEl(null)
    };

    const changeStatus = (isActive) => {
        setFlagEdit(0);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [elemIndex, setElemIndex] = useState('')

    const handlePopper = (event, nElem) => {
        if (flagEdit === 1) {
            setFlagEdit(0)
        }
        setElemIndex(nElem)
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const [ outsideOpen, setOutsideOpen ] = useState(false)

    const handleOutside = () => {
        setOutsideOpen(!outsideOpen)
    }

    const confirmDeleteService = (event) => {
        event.preventDefault()
        setOutsideOpen(false)
        let allServices = listServices.filter((elem, ind) => elemIndex !== ind)
        setListServices(allServices)
        setAnchorEl(null)
        handleSnackbar()
        setElemIndex('')
    };

    useEffect(() => {
        if (handleEditFlag) {
            handleEditFlag(flagEdit)
        }
        if (flagEdit) {
            setExpanded(false)
        }
    }, [flagEdit, handleEditFlag])

    const openPopper = Boolean(anchorEl);
    const classes = useStyles()
    
  return (
    <>
        {elemIndex !== undefined && outsideOpen ?
            <Popup
                open={outsideOpen}
                handleClose={handleOutside}
                title='Seguro que deseas eliminar este servicio?'
                subtitle='Recuerda que una vez eliminado ya no podrás recuperarlo. Si no deseas continuar da click en el botón "Cancelar"'
                primaryButton={true}
                primaryButtonVariant='primarySolidOutlined'
                primaryButtonText='Sí, eliminar'
                primaryFunction={confirmDeleteService}
                secondaryButton={true}
                secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
                secondaryButtonVariant='primary'
            /> : null
        }
        <Popover
            open={openPopper}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
            }}
        >
            <List className={classes.list} component="nav" aria-label="secondary mailbox folders">
                <ListItem
                    className={classes.listItem}
                    button
                >
                    <ListItemText 
                        onClick={FnEditService}
                        className={classes.listItemText} 
                        primary="Editar servicio"
                    />
                </ListItem>

                <ListItem
                    className={classes.listItem}
                    button
                >
                    <ListItemText 
                        onClick={handleOutside}
                        className={classes.listItemText} 
                        primary="Eliminar servicio"
                    />
                </ListItem>
            </List>                
        </Popover>

        <div style={{ width: '100%', maxWidth: 568 }}>
            {listServices && listServices.map((elem, index) => {
                const { discount, price, description, typeCurrency } = elem;
                if (index === elemIndex && flagEdit === 1) {
                    return (
                        <AddServices
                            flagEdit={flagEdit}
                            evento={changeStatus}
                            item={elemIndex}
                            helper={helper}
                            helperTrue={helperTrue}
                            helperFalse={helperFalse}
                            getValues={getValues}
                            listServices={listServices}
                            setListServices={setListServices}
                            setAnchorEl={setAnchorEl}
                            setElemIndex={setElemIndex}
                            changeStatus={changeStatus}
                            calculateProposalDetails={calculateProposalDetails}
                        />
                    )
                }
                return (
                    <div className="serviceAdded" key={index}>
                        <div className="serviceAdded_limit">
                            <ul className="serviceAdded_container">
                                <li className="serviceAdded_container_list">
                                    <div className="serviceAdded_container_info">
                                        {description ?
                                            <p className="serviceAdded_paragraph1">{description}</p> :
                                            null
                                        }
                                        {price || price === 0 ?
                                            <p className="serviceAdded_paragraph3">
                                                {`Precio: ${price}${(price || price === 0) && typeof price === 'string' ? '' : '.00'}
                                                    ${typeCurrency ? (
                                                        typeCurrency === 'USD Dólar' ? 'USD' :
                                                        typeCurrency === 'EUR Euro' ? 'EUR' :
                                                        typeCurrency === 'MXN Peso mexicano' ? 'MXN' :
                                                        'MXN'
                                                    ) : ''}
                                                `}
                                            </p> :
                                            null
                                        }
                                        {discount || discount === 0 ?
                                            <p className="serviceAdded_paragraph3">
                                                {`Descuento: ${discount}${(discount || discount === 0) && typeof discount === 'string' ? '' : '.00'}
                                                    ${typeCurrency ? (
                                                        typeCurrency === 'USD Dólar' ? 'USD' :
                                                        typeCurrency === 'EUR Euro' ? 'EUR' :
                                                        typeCurrency === 'MXN Peso mexicano' ? 'MXN' :
                                                        'MXN'
                                                    ) : ''}
                                                `}
                                            </p> :
                                            null
                                        }
                                    </div>
                                </li>
                            </ul>
                            <img
                                src="/img/expand/menu-options.svg"
                                alt="service"
                                className="serviceAdded_optionsImg"
                                onClick={(event) => handlePopper(event, index)}
                            />
                        </div>
                    </div>
                )})
            }
        </div>
    </>
  );
};

export default ServiceAdded;